/**
 * メッセージテンプレート選択ボタン
 **/
$(function(){
  if($('.select-message-template-btn').length) {
    $('.select-message-template-btn').on('click', function () {
      if (!confirm('メッセージテンプレートを反映します。よろしいですか？')) {
        return false;
      }
      $('#form-send-message textarea[name="body"]').val($(this).next().val());
      $('#form-send-message textarea[name="body"]').trigger('input');
      autosize.update($('#form-send-message textarea[name="body"]'));
      return false;
    });
  }
});

// 学生詳細やメッセージモーダル、メッセージテンプレートで使用
$(function(){
  if($('.js-message-textarea-1000').length) {
    autosize($('.autosize'));
    // ロード時の文字数
    var cntVal = $('.js-message-textarea-1000').val();
    var textareaReplace = cntVal.replace(/\r?\n/g, '');
    var textAreaCount = textareaReplace.length;
    $('#js-number-text-content-1000').text(textAreaCount);
    //入力時のイベント
    $('.js-message-textarea-1000').on('input', function(){
        //文字数を取得
      var cnt = $(this).val();
      var textareaStr = cnt.replace(/\r?\n/g, '');
      var textAreaCount = textareaStr.length;
      $('#js-number-text-content-1000').text(textAreaCount);
      //現在の文字数を表示
      if(textAreaCount > 1500){
        $('#js-number-text-content-1000').addClass('over');
      }else{
        $('#js-number-text-content-1000').removeClass('over');
      }
    });
    $('.js-message-textarea-1000').blur(function() {
        var cnt = $(this).val();
        var textareaStr = cnt.replace(/\r?\n/g, '');
      var textAreaCount = textareaStr.length;
        //背景色を白にする
        if(textAreaCount > 1500) {
          alert('メッセージは1500文字以内でお願いいたします。');
        }
      });
  }
});


$(function() {
  if($('#messageAreaOn').length) {
    $('#messageAreaOnBtn').on('click',function() {
      $('#messageAreaOn').fadeIn();
      $(this).addClass('active');
      var position = $("#messageAreaOn").offset().top;
      $("html,body").animate({
        scrollTop : position
      }, {
        queue : false
      });
    });
  };
});
